import { api } from 'config';

import { Response } from 'types';

import { ActiveLicense } from './types';

export async function getActiveLicense(options: { storeUuid?: string }) {
  if (!options.storeUuid) return null;
  const request = await api.get<Response<ActiveLicense>>('/v1/subscriptions/active-license/', {
    params: {
      store_uuid: options.storeUuid,
    },
  });
  const response = request.data.data;

  return response;
}
